import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  TextField,
} from "@mui/material";

const GoogleNumberOtpModal = ({
  google_OTP_Pop_flag=google_OTP_Pop_flag,
  onClose,
  number,
  otp,
setOtp,

  otpError,
  otpErrorMsg,
  googleOtpSubmit,
  closeOTpPop,
  googleAddnumber,
  
}) => {
  const [time, setTime] = useState(30);
  const inputRef = useRef(null);

  // Timer logic
  useEffect(() => {
    if (!google_OTP_Pop_flag) return;
    setTime(30);
    const timer = setInterval(() => {
      setTime((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [google_OTP_Pop_flag]);

  // Focus input when modal opens
  useEffect(() => {
    if (inputRef.current && google_OTP_Pop_flag) inputRef.current.focus();
  }, [google_OTP_Pop_flag]);

  // Handle resend OTP
  const handleResend = () => {
    googleAddnumber && googleAddnumber();
    setTime(30);
    if (inputRef.current) inputRef.current.focus();
  };


    const handleOtp = (e) => {
    setOtp(e.target.value);
    //console.log(e.target.value) // Update state with the input value
  };


  return (
    <Dialog
      open={google_OTP_Pop_flag}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          width: "90%",
          maxWidth: 380,
          textAlign: "center",
          p: 2,
        },
      }}
    >
      <DialogContent>
        {/* Header SVG */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
          <svg
            style={{ width: "84px" }}
            xmlns="http://www.w3.org/2000/svg"
            width="142"
            height="66"
            viewBox="0 0 142 66"
            fill="none"
          >
            <g clipPath="url(#clip0_61_2282)">
              <rect width="142" height="66" rx="33" fill="white" />
              <path
                d="M112.017 21.564C109.527 21.564 107.503 23.6012 107.503 26.1084V30.5345H116.54V26.1084C116.54 23.6012 114.506 21.564 112.017 21.564Z"
                fill="#029646"
              />
              <path
                d="M124.558 0H17.4418C7.85532 0 0 7.88827 0 17.5076V48.3694C0 58.0039 7.85532 65.877 17.4418 65.877H124.558C134.145 65.877 142 58.0039 142 48.3694V17.5076C142 7.88827 134.145 0 124.558 0ZM124.93 45.4439C124.93 47.3205 123.398 48.8545 121.531 48.8545H102.512C100.642 48.8545 99.113 47.3205 99.113 45.4439V33.942C99.113 32.0654 100.642 30.5314 102.512 30.5314H102.971V26.1053C102.971 21.094 107.029 17.0165 112.017 17.0165C117.008 17.0165 121.069 21.091 121.069 26.1053V30.5314H121.528C123.392 30.5314 124.927 32.0654 124.927 33.942L124.93 45.4439Z"
                fill="#029646"
              />
            </g>
            <defs>
              <clipPath id="clip0_61_2282">
                <rect width="142" height="66" rx="33" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Box>

        {/* Title and Message */}
        <Typography variant="h6" fontWeight={700}>
          Enter OTP
        </Typography>
        <Typography variant="body2" sx={{ mt: 1.5, color: "#475569" }}>
          Enter the 4-digit code sent to your number{" "}
          <strong>{number}</strong>.
        </Typography>

        {/* OTP Input */}
        <Box sx={{ mt: 3 }}>
       <TextField
            inputRef={inputRef}
            value={otp}
            onChange={handleOtp}
            placeholder="Enter OTP"
            type="number"
            fullWidth
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*",
              style: {
                textAlign: "center",
                fontSize: "18px",
                letterSpacing: "4px",
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                border: "2px solid #8080805e",
              },
              // 🔻 Remove number field up/down arrows
              "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
              "& input[type=number]": {
                MozAppearance: "textfield",
              },
            }}
          />
          {otpError && (
            <Typography
              variant="caption"
              sx={{
                color: "rgba(234,67,53,1)",
                textAlign: "start",
                display: "block",
                mt: 1,
              }}
            >
              {otpErrorMsg}
            </Typography>
          )}
        </Box>

        {/* Timer / Resend */}
        {time > 0 ? (
          <Typography variant="body2" sx={{ mt: 2, color: "gray" }}>
            Didn’t receive code? Resend in {time}s
          </Typography>
        ) : (
          <Box sx={{ mt: 2, textAlign: "right" }}>
            <Button
              onClick={handleResend}
              sx={{
                textTransform: "none",
                color: "rgba(0,177,119,1)",
                fontSize: "13px",
              }}
            >
              Resend OTP
            </Button>
          </Box>
        )}

        {/* Action Buttons */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
          <Button
            onClick={closeOTpPop}
            variant="outlined"
            sx={{
              borderColor: "rgba(0,177,119,1)",
              color: "rgba(0,177,119,1)",
              borderRadius: "10px",
              width: "48%",
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={googleOtpSubmit}
            variant="contained"
            disabled={!otp || otp.length !== 4} // ✅ Enable only for 4 digits
            sx={{
              backgroundColor:
                !otp || otp.length !== 4
                  ? "rgba(0,177,119,0.5)"
                  : "rgba(0,177,119,1)",
              borderRadius: "10px",
              width: "48%",
              fontWeight: 700,
              color: "white",
              "&:hover": {
                backgroundColor:
                  !otp || otp.length !== 4
                    ? "rgba(0,177,119,0.5)"
                    : "rgba(0,150,100,1)",
              },
            }}
          >
            Submit
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default GoogleNumberOtpModal;
